export default __webpack_public_path__ + "images/default-logo.8aea958f8ca1477cca2e2139e69b5934.png";